subLines